import request from "@/utils/httpRequest";

// todo 拖拽变化
export function UpdataDraggable(data) {
  return request({
    url: "sys/config/update",
    method: "PUT",
    data,
  });
}

export function DeleteConfig(data) {
  return request({
    url: "sys/config/delete",
    method: "DELETE",
    data,
  });
}

export function ResetPassword(data) {
  return request({
    url: "sys/user/reset/password",
    method: "PUT",
    data,
  });
}

//
export function QueryMobileHome() {
  return request({
    url: "open/api/mobileHome",
    method: "GET",
  });
}
